import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   StrongText,
} from '@dreryk/react-components';

import { translationKeys } from '../translations';

import { WaitlistEntryRemoveAction } from './WaitlistEntryRemoveModal.actions';

type WaitlistEntryRemoveModalProps = {
   entryId: number;
   onClose: VoidFunction;
   patientFullName: string;
};

export const WaitlistEntryRemoveModal = (props: WaitlistEntryRemoveModalProps): ReactElement => {
   return (
      <Modal testId={'waitlistEntryRemove'} title={translationKeys.removingEntry} width={ModalWidth.NORMAL}>
         <div>
            <Trans
               i18nKey={translationKeys.areYouSureRemovingPatientEntry}
               values={{ patientFullName: props.patientFullName }}
               components={{ bold: <StrongText testId={'patientFullName'} /> }}
            />
         </div>
         <WaitlistEntryRemoveAction entryId={props.entryId} onSuccess={props.onClose}>
            {({ removeEntry }) => <ModalConfirmButton label={translationKeys.remove} onClick={removeEntry} />}
         </WaitlistEntryRemoveAction>
         <ModalCancelButton onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
      </Modal>
   );
};
